import { getQueryParams } from "../utils/helperFunctions";
let instance;

// Within the constructor, making sure the class hasn't already been instantiated.
class ChatBotMeta {
  constructor() {
    if (instance) {
      console.error("You can create only one instance!");
      return;
    }
    this.chatBotMeta = {};
    instance = this;
  }

  get() {
    return { ...getQueryParams(), ...this.chatBotMeta };
  }

  set(value) {
    this.chatBotMeta = { ...this.chatBotMeta, ...value };
    return this.chatBotMeta;
  }
}

const singletonChatBotMeta = new ChatBotMeta();
export default singletonChatBotMeta;
